<template>
  <div class="iDalgo-Card">
    <div class="iDalgo-Card__Picture" :style="{ 'background-image': 'url(' + picture + ')' }">
      <div class="iDalgo-Card__Picture__Whitemark"></div>
      <div class="iDalgo-Card__Delete" @click="handleDelete">
        <svgicon name="cross" :original="true"></svgicon>
      </div>
    </div>
    <div class="iDalgo-Card__Content">
      <h4>{{ title }}</h4>
    </div>
  </div>
</template>

<script>
export default {
  name: 'iDalgo-Card',
  props: {
    picture: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleDelete () {
      this.$emit('click', this.key)
    }
  },
  data () {
    return {
      active: false
    }
  }
}
</script>

<style lang="scss">
.iDalgo-Card {
  display: flex;
  flex-flow: column;
  padding: 0;
  border-radius: 3px;
  width: 80px;
  box-shadow: 0 2px 9px 0 rgba(0,0,0,0.22);
  position: relative;
  flex-grow: 0;
  margin: 8px;
  transition: box-shadow 0.3s;

  &__Picture {
    display: flex;
    padding: 0;
    margin: 0;
    background: #fff center center no-repeat;
    background-size: cover;
    width: 100%;
    height: 82px;
    transition: all 0.2s;
    position: relative;

    &__Whitemark {
      position: absolute;
      top: 0;
      left: 0;
      width: 29px;
      height: 29px;
      background-color: #EF1219;
      border-radius: 0 0 6px 0;
      opacity: 0;
      transition: all 0.2s;
    }
  }

  &__Content {
    padding: 5px;
    background: #fff;
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
    transition: all 0.2s;
    overflow: hidden;

    h4 {
      color: #737373;
      margin: 0;
      padding: 0;
      font-family: "robotolight";
      font-size: 12px;
      line-height: 20px;
      text-align: center;
      transition: all 0.2s;
      color: $color1;
    }

    b {
      color: #737373;
      font-family: "robotobold";
      font-size: 12px;
      line-height: 15px;
      text-align: center;
      transition: all 0.2s;
    }
  }

  &__Delete {
    position: absolute;
    background: $color2;
    cursor: pointer;
    width: 16px;
    height: 16px;
    top: 0x;
    right: 0px;
    line-height: 14px;
    text-align: center;
    font-size: 10px;
    color: #fff;
    opacity: 0;
    transform-origin: 100% 0%;
    transform: scale(0);
    transition: opacity 0.2s 0.2s, transform 0.4s 0.2s;

    svg {
      width: 16px;
      height: 16px;

      & [pid="0"] {
        fill: $white;
      }

      & [pid="1"] {
        fill: $color2;
      }
    }
  }

  &.disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }

  &:hover {
    box-shadow: 0 4px 35px 0 rgba(0,0,0,0.22);
    transition: box-shadow 0.5s;

    .iDalgo-Card__Delete {
      opacity: 1;
      transform: scale(1);
    }
  }

  &.active {
    opacity: 1;
    cursor: pointer;
    box-shadow: 0 4px 35px 0 rgba(0,0,0,0.22);
    .iDalgo-Card__Content {
      background-color: #FDE97E;
      h4, b {
        color: #000;
      }
    }

    .iDalgo-Card__Picture__Whitemark {
      opacity: 1;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/iDalgo-Card.vue